import React, { useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import ModalGenerateOrder from './generateorderModal';

const GenerateOrderButton = (props) => {
    const [isGenerate, setisGenerate] = useState(false);
  const [rowData, setrowData] = useState(null);

      const openGenerateModal = () => {
        setisGenerate(true)
        setrowData(props.data)
      }

     const closeModal = (alert) => {
        props.agGridReact.props.onDelete(alert);
        setisGenerate(false)
      }

      const closeGO = (alert) => {
        setisGenerate(false)
      }

      const showError = (alert) => {
        props.agGridReact.props.onEdit(alert);
        // setisGenerate(true)
      }

        return (
          <>
          {props.data.status_code == "EXP" || props.data.status_code == "INACT" || props.data.is_vehicle_utilised == "Yes" ? (
              "NA"
          ) : (
          <>
            <Button
              onClick={openGenerateModal}
              basic
              size="mini"
              type="button"
              icon
            >
              {"Generate Order"}
            </Button>
            </>
            )}
              
              {isGenerate && <ModalGenerateOrder success={props.agGridReact.props.onDelete} movement_type={"import"} OpenModal={isGenerate} data={rowData} CloseModal={closeModal} closeGO={closeGO} error={showError} />}
                
                
          </>
        );
      }

export default GenerateOrderButton;